module.exports = __webpack_public_path__ + "static/media/opengraphcover.6dbe04d1.png";